export default __webpack_public_path__ + "57a5b1d63e7c14fa048ea03495e4e7d5.svg";